<template>
	<div class="view flex-parent">
		<div
			class="flex-center main container border-l player-name-div"
			id="player-name-div"
		>
			<div class="join-game-form">
				<h1 class="mb-24">Join a game of NaxuiGogi</h1>
				<form id="player-name-form">
					<label
						for="playerName"
						id="player-name-label"
						class="player-name-label"
						:class="[playerNameLabel.class]"
						>{{ playerNameLabel.text }}</label
					>
					<player-name-input
						v-model="playerName"
						placeholder="My name Borat"
					></player-name-input>
					<label
						for="roomCode"
						id="room-code-label"
						class="player-name-label mt-16"
						:class="[roomCodeLabel.class]"
						>{{ roomCodeLabel.text }}</label
					>

					<div class="form-div">
						<room-code-input
							@input="resetRoomCodeLabel"
							v-model="roomCode"
							placeholder="1234"
						/>
						<div class="button-div">
							<primary-button
								class="btn m"
								@click.prevent="handleJoin"
								:disabled="!playerName || !roomCode"
								>Join game</primary-button
							>
						</div>
					</div>
				</form>
			</div>
			<hr class="mt-16" />
			<h4 class="align-c mt-24 tc-secondary">
				Don't have a game room yet?
			</h4>
			<secondary-button
				class="new-game mt-8 btn secondary m"
				@click="tryCreateNewGame"
				>Create new game</secondary-button
			>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrimaryButton from "@/components/ui/PrimaryButton";
import SecondaryButton from "@/components/ui/SecondaryButton";
import RoomCodeInput from "@/components/ui/RoomCodeInput";
import PlayerNameInput from "@/components/ui/PlayerNameInput";

export default {
	name: "Login",
	components: {
		PrimaryButton,
		SecondaryButton,
		RoomCodeInput,
		PlayerNameInput,
	},
	data() {
		return {
			playerName: "",
			playerNameLabel: {
				text: "Your name",
				class: {
					error: false,
					success: false,
				},
			},
			roomCode: "",
			roomCodeLabel: {
				text: "Game room code",
				class: {
					error: false,
					success: false,
				},
			},
		};
	},
	computed: {
		...mapGetters(["currentError"]),
	},
	methods: {
		...mapActions(["tryJoinGame", "tryCreateNewGame"]),
		logData() {
			// console.log("Player name:", this.playerName);
			// console.log("Room code:", this.roomCode);
		},
		routeToGame(aRoomCode) {
			this.$router.push({ name: `Game`, params: { gameId: aRoomCode } });
		},
		resetRoomCodeLabel() {
			// Reset error/success message
			this.roomCodeLabel = {
				text: "Game room code",
				class: {
					error: false,
					success: false,
				},
			};
		},

		handleJoin() {
			if (this.roomCode && this.playerName) {
				this.tryJoinGame({
					aRoomCode: this.roomCode,
					aName: this.playerName,
				});
			}
		},
	},
	watch: {
		currentError(newVal) {
			this.roomCodeLabel.text = newVal;
			this.roomCodeLabel.class.error = true;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";
@import "../assets/scss/input.scss";
@import "../assets/scss/lobby.scss";

.join-game-form {
	display: block;
}

.new-game {
	width: 100%;
}
</style>
